import { useState, useCallback } from 'react';
import { UI } from 'new/modules/ai/constants';

/**
 * Hook for handling copy-to-clipboard with temporary success state
 * @param duration Duration to show success state in ms
 */
export function useCopy(duration: number = UI.COPY_FEEDBACK_DURATION) {
  const [copiedField, setCopiedField] = useState<string | null>(null);

  const copy = useCallback(
    async (text: string, fieldId: string) => {
      try {
        await navigator.clipboard.writeText(text);
        setCopiedField(fieldId);
        setTimeout(() => setCopiedField(null), duration);
        return true;
      } catch (err) {
        console.error('Failed to copy text: ', err);
        return false;
      }
    },
    [duration],
  );

  return {
    copiedField,
    copy,
    isCopied: (fieldId: string) => copiedField === fieldId,
  };
}
